import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7b812be0")
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "font-ops" }
const _hoisted_3 = { class: "font-ops" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "h-28" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "gap" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_TokenFarmInput = _resolveComponent("TokenFarmInput")!
  const _component_BalActionSteps = _resolveComponent("BalActionSteps")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, {
    shadow: "none",
    noBorder: "",
    changeType: _ctx.changeType
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ACTIONTYPE, (item, index) => {
          return (_openBlock(), _createBlock(_component_BalBtn, {
            key: index,
            color: _ctx.state.navCurIndex === index ? _ctx.navBtnActiveColor : _ctx.navBtnColor,
            onClick: ($event: any) => (_ctx.chooseNavIndex(index)),
            changeType: _ctx.changeType,
            label: item,
            block: ""
          }, null, 8, ["color", "onClick", "changeType", "label"]))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["flex place-content-between mb-2", _ctx.balanceNameColor])
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.actionTitle), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.fNum2(_ctx.actionTitleValue)), 1)
      ], 2),
      _createElementVNode("a", {
        class: _normalizeClass([_ctx.state.navCurIndex === 0 ? 'visible' : 'invisible', "text-custom-black-350 text-sm mb-3"]),
        target: "_blank",
        href: `/#/pool/${_ctx.pool?.id}`
      }, "Get LP tokens ", 10, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_TokenFarmInput, {
          customBalance: _ctx.actionTitleValue,
          address: _ctx._tokenInAddress,
          name: "tokenIn",
          "onUpdate:amount": _ctx.handleInAmountChange,
          disabled: _ctx.tradeLoading,
          containerBg: _ctx.containerBg,
          changeType: _ctx.changeType,
          disableBalance: _ctx.state.navCurIndex === 2,
          actionType: _ctx.state.navCurIndex,
          amount: _ctx.state.inputAmount
        }, null, 8, ["customBalance", "address", "onUpdate:amount", "disabled", "containerBg", "changeType", "disableBalance", "actionType", "amount"])
      ]),
      _hoisted_6,
      _createVNode(_component_BalActionSteps, {
        disabled: _ctx.actionBtnDisabled,
        showStep: false,
        actions: _ctx.actions,
        changeType: "changeType",
        color: _ctx.color,
        showBtn: true
      }, null, 8, ["disabled", "actions", "color"])
    ]),
    _: 1
  }, 8, ["changeType"]))
}